export default __webpack_public_path__ + "static/skills-d380d4b6ea4dce9fe9868f7453b7d3c4.png";